import axios from '../common/CommonConfigRestService'

export default {
  executeBasicAxiosGet (url) {
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(response => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
    })
  },
  executeBasicAxiosPost (url, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: url,
        data: data
      }).then((response) => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  executeBasicAxiosPut (url, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'put',
        url: url,
        data: data
      }).then((response) => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  executeBasicAxiosRemove (url) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: url
      }).then((response) => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
